export default __webpack_public_path__ + "static/media/arny.a64e8236.jpg";